import { useContext, useState } from "react";
import { useHistory, withRouter } from "react-router-dom";

// Components
import Header from "./Header";

// Context
import { ConferencesContext } from "../../context/conferences";

// Hooks
import { useDocumentScrollThrottled } from "../../hooks/scroll/useDocumentScrollThrottled";

const HeaderContainer = (props) => {
    const { location } = props;

    /**
     * Router Hooks
     */

    const history = useHistory();

    /**
     * useContext
     */

    const { featuredConference } = useContext(ConferencesContext);

    /**
     * useState
     */

    const [previousPathname, setPreviousPathname] = useState(location.pathname);
    const [selectedFilter, setSelectedFilter] = useState(null);
    const [shouldHideHeader, setShouldHideHeader] = useState(false);
    const [shouldShowFilterTags, setShouldShowFilterTags] = useState(false);
    const [shouldShowShadow, setShouldShowShadow] = useState(false);

    /**
     * Custom Hooks
     */

    const MINIMUM_SCROLL = 80;
    const TIMEOUT_DELAY = 200;

    useDocumentScrollThrottled((callbackData) => {
        const { previousScrollTop, currentScrollTop } = callbackData;
        const isScrolledDown = previousScrollTop < currentScrollTop;
        const isMinimumScrolled = currentScrollTop > MINIMUM_SCROLL;

        setShouldShowShadow(currentScrollTop > 2);

        setTimeout(() => {
            setShouldHideHeader(isScrolledDown && isMinimumScrolled);
        }, TIMEOUT_DELAY);
    });

    /**
     * End Hooks
     */

    function goToConference({ scrollToRegister }) {
        const registerQuery = scrollToRegister ? "?scroll=register" : "";
        history.push(`/conferences/${featuredConference.slug}${registerQuery}`);
    }

    function goToHome() {
        history.push(`/`);
    }

    function goToSymphony() {
        window.open(
            "https://symphony.com/",
            "_blank",
            "noopener",
            "noreferrer"
        );
    }

    function goToSocial(platform) {
        const urls = {
            linkedin: "https://www.linkedin.com/company/symphonycomm/",
            twitter: "https://twitter.com/symphony",
            youtube: "https://www.youtube.com/c/SymphonyComm"
        };
        window.open(urls[platform], "_blank", "noopener", "noreferrer");
    }

    function handleSelectFilter(key, bool) {
        toggleFilterTagsDisplay(bool);
        setSelectedFilter(key);
    }

    function toggleFilterTagsDisplay(bool) {
        setShouldShowFilterTags((prev) => bool || !prev);
    }

    return (
        <Header
            {...props}
            conference={featuredConference}
            goToConference={goToConference}
            goToHome={goToHome}
            goToSocial={goToSocial}
            goToSymphony={goToSymphony}
            handleSelectFilter={handleSelectFilter}
            history={history}
            previousPathname={previousPathname}
            selectedFilter={selectedFilter}
            setPreviousPathname={setPreviousPathname}
            shouldHideHeader={shouldHideHeader}
            shouldShowFilterTags={shouldShowFilterTags}
            shouldShowShadow={shouldShowShadow}
            toggleFilterTagsDisplay={toggleFilterTagsDisplay}
        />
    );
};

export default withRouter(HeaderContainer);
